<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr :id="'r-' + item.ID">
                            <td>{{ item.OrderTransactionCode }}</td>
                            <td>{{ item.OrderCodeCN }}</td>
                            <td>{{ (item.PackageType === 1 ? 'KG' : '') + item.OrderID }}</td>
                            <td>{{ item.Username }}</td>
                            <td class="text-right" v-if="weightEditable">
                                <v-edit-dialog :return-value.sync="item.Weight" large lazy persistent @save="saveItem(item)">
                                <div>{{ item.Weight }}</div>
                                <template v-slot:input>
                                    <v-text-field v-model="item.Weight" type="number" step=".1" label="Cân nặng" :disabled="item.Status == package_status_enum.KH_DA_NHAN" single-line autofocus></v-text-field>
                                </template>
                                </v-edit-dialog>
                            </td>
                            <td class="text-right" v-if="!weightEditable">{{ item.Weight }}</td>
                            <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
                            <td>{{ item.CreatedDate | display_date }}</td>
                            <td class="text-center">
                                <v-icon v-if="moduleRole & 4096" medium class="mr-2" @click="gotoDetail(item.PackageType, item.OrderID, item.UID)">visibility</v-icon>
                                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.Weight, item.OrderTransactionCode, item.Username, item.OrderID, item.NumberOfCode)">print</v-icon>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { print_transaction } from "@/commons/hpod";
import Vue from 'vue';
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            package_status: configs.PACKAGE_STATUS,
            package_status_enum: configs.PACKAGE_STATUS_ENUM,
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "transactioncode_list",
            filterConditions: [],
            quickFilterConditions: [],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            items: state => state.orderTransaction.all.data,
            total_rows: state => state.orderTransaction.all.total,
            loading: state => state.orderTransaction.loading,
        }),
        headers() {
            let dataType = configs.DATA_TYPE;
            const isFilter = this.adminRoles;
            return [
                {
                    text: "Mã vận đơn",
                    value: "OrderTransactionCode",
                    filterable: isFilter,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã đơn CN",
                    value: "OrderCodeCN",
                    filterable: isFilter,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "OrderID",
                    value: "OrderID",
                    quickSearch: isFilter,
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    filterable: isFilter,
                    dataType: dataType["String"]
                },
                {
                    text: "Cân nặng",
                    value: "Weight",
                    filterable: isFilter,
                    dataType: dataType["Number"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: isFilter,
                    dataType: dataType["Enum"],
                    values: configs.PACKAGE_STATUS
                },
                {
                    text: "Ngày tạo",
                    value: "CreatedDate",
                    filterable: isFilter,
                    dataType: dataType["Date"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ];
        },
        adminRoles() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager); 
        },
        weightEditable() {
            return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN); 
        },
        moduleRole() {
            return this.$store.state.authentication.role.Module;
        },
    },
    methods: {
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        printTransaction(weight, transactionCode, customerName, orderId, numberOfCode) {
            print_transaction(weight, transactionCode, customerName, orderId, numberOfCode);
        },
        saveItem:_.debounce(
        function(item) {
            var data = {
            ...item
            };
            data.Type = "transaction";
            data.ModifiedBy = this.$store.state.authentication.user.username;
            item.Status = data.Status = data.Weight > 0 ? configs.PACKAGE_STATUS_ENUM.DA_VE_VN : configs.PACKAGE_STATUS_ENUM.DANG_DI_CHUYEN;
            delete data.CreatedDate;
            delete data.CreatedBy;
            this.$store.dispatch("orderTransaction/postOrderTransaction", data);
        }, 500, {leading: false, trailing: true}),
        // Only admin can view table, staff need search by code
        filter_data: function () {
            if(this.adminRoles) {
                var param = {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                };
                this.$store.dispatch("orderTransaction/getList", param);
            }
            else if(this.quickFilterConditions.length == 0){
                this.$store.commit("orderTransaction/setList", {data: [], total: 0});
            }
            else {
                this.$store.dispatch("orderTransaction/getList", {
                    pagination: this.pagination,
                    filter: [],
                    quickFilter: this.quickFilterConditions.flatMap(obj =>{ 
                        return [
                            {
                                column: obj.column,
                                value: obj.value,
                                condition: "s_equal"
                            },
                            {
                                column: obj.column,
                                value: obj.value + '-',
                                condition: "contain"
                            }
                            ];
                    })
                });
            }
        },
        gotoDetail: function (type, id, uid) {
            if (type) {
                let routeData = this.$router.resolve({
                    name: "DepositDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    },
                    query: {
                        'uid': uid
                    }
                });
                window.open(routeData.href, "_blank");
            } else {
                let routeData = this.$router.resolve({
                    name: "OrderDetail",
                    params: {
                        Pid: id,
                        title: `Chi tiết đơn hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        }
    },
    mounted() {
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
